import * as React from 'react'

export const SVG_Ellipsis = () => (
    <svg width="32" height="33" viewBox="0 0 32 33">
        <g fill="#4f5b68" fillRule="evenodd">
            <path
                id="a"
                d="M22.002 16.499c0-1.109.903-2.013 2.013-2.013 1.11 0 2.012.904 2.012 2.013a2.016 2.016 0 0 1-2.012 2.015 2.016 2.016 0 0 1-2.013-2.015zm-8.015 0c0-1.109.903-2.013 2.013-2.013 1.11 0 2.012.904 2.012 2.013A2.016 2.016 0 0 1 16 18.514a2.016 2.016 0 0 1-2.013-2.015zm-8.014 0c0-1.109.903-2.013 2.013-2.013 1.109 0 2.012.904 2.012 2.013 0 1.11-.903 2.014-2.012 2.014a2.016 2.016 0 0 1-2.013-2.014z"
            />
        </g>
    </svg>
)
